import React from "react";
import { IoClose } from "react-icons/io5";
import { FaCheck, FaTimes, FaMicrophone, FaVolumeUp, FaVideo } from "react-icons/fa";
import { PiWarningFill } from "react-icons/pi";
import "../assets/css/device-error-dialog.css";

const ERROR_MESSAGES = {
  browser_unsupported: {
    titre: "Navigateur non supporté",
    message:
      "Votre navigateur ne prend pas en charge la détection des périphériques.",
    solutions: [
      "Utilisez Chrome, Firefox ou Edge",
      "Mettez à jour votre navigateur",
    ],
  },
  insecure_context: {
    titre: "Connexion non sécurisée",
    message:
      "L'accès aux périphériques nécessite une connexion sécurisée (HTTPS).",
    solutions: [
      "Accédez à ce site via HTTPS",
      "Contactez l'administrateur du site",
    ],
  },
  permission_denied: {
    titre: "Accès refusé",
    message:
      "L'accès aux périphériques a été refusé par votre navigateur.",
    solutions: [
      "Cliquez sur l'icône du cadenas à gauche de l'URL",
      "Autorisez l'accès au micro et à la caméra",
      "Actualisez la page",
    ],
  },
  unknown: {
    titre: "Erreur de détection",
    message: "Une erreur est survenue lors de la détection des périphériques.",
    solutions: [
      "Actualisez la page",
      "Essayez un autre navigateur",
    ],
  },
};

function DeviceStatusList({ deviceStatus }) {
  const items = [
    {
      icon: <FaMicrophone />,
      label: "Microphone",
      available: deviceStatus.microphone.available,
      count: deviceStatus.microphone.count,
    },
    {
      icon: <FaVolumeUp />,
      label: "Haut-parleur",
      available: deviceStatus.speaker.available,
      count: deviceStatus.speaker.count,
    },
    {
      icon: <FaVideo />,
      label: "Caméra",
      available: deviceStatus.camera.available,
      count: deviceStatus.camera.count,
    },
  ];

  return (
    <div className="device-status-list">
      {items.map((item) => (
        <div
          key={item.label}
          className={`device-status-row ${
            item.available ? "available" : "missing"
          }`}
        >
          <span className="device-status-icon">{item.icon}</span>
          <span className="device-status-label">{item.label}</span>
          <span className="device-status-badge">
            {item.available ? (
              <FaCheck className="device-status-check" />
            ) : (
              <FaTimes className="device-status-x" />
            )}
          </span>
        </div>
      ))}
    </div>
  );
}

export default function DeviceErrorDialog({
  type,
  deviceStatus,
  mediaError,
  theme,
  onClose,
  onRetry,
}) {
  const isDark = theme === "dark";

  let titre, message, solutions;

  if (type === "device_check") {
    if (deviceStatus?.error) {
      const errInfo = ERROR_MESSAGES[deviceStatus.error] || ERROR_MESSAGES.unknown;
      titre = errInfo.titre;
      message = deviceStatus.errorDetail
        ? `${errInfo.message}\n\nDétail : ${deviceStatus.errorDetail}`
        : errInfo.message;
      solutions = errInfo.solutions;
    } else {
      titre = "Périphériques manquants";
      message =
        "Certains périphériques nécessaires à la réunion n'ont pas été détectés.";
      solutions = [
        "Branchez votre périphérique externe (micro, webcam, haut-parleur)",
        "Assurez-vous qu'il est bien reconnu par votre système",
        "Autorisez l'accès dans votre navigateur (icône cadenas près de l'URL)",
        "Actualisez la page pour re-détecter les périphériques",
      ];
    }
  } else if (type === "media_error" && mediaError) {
    titre = mediaError.titre;
    message = mediaError.message;
    solutions = mediaError.solutions;
  }

  return (
    <div className="device-error-overlay">
      <div
        className={`device-error-dialog ${isDark ? "dark" : "light"}`}
      >
        <button className="device-error-close" onClick={onClose}>
          <IoClose />
        </button>

        <div className="device-error-icon-wrapper">
          <PiWarningFill className="device-error-warning-icon" />
        </div>

        <h3 className="device-error-title">{titre}</h3>

        {type === "device_check" && deviceStatus && !deviceStatus.error && (
          <DeviceStatusList deviceStatus={deviceStatus} />
        )}

        <p className="device-error-message">{message}</p>

        {solutions && solutions.length > 0 && (
          <>
            <p className="device-error-solutions-label">Solutions :</p>
            <ul className="device-error-solutions">
              {solutions.map((s, i) => (
                <li key={i}>{s}</li>
              ))}
            </ul>
          </>
        )}

        <div className="device-error-actions">
          <button className="device-error-btn-primary" onClick={onRetry}>
            Réessayer
          </button>
          <button className="device-error-btn-secondary" onClick={onClose}>
            Fermer
          </button>
        </div>
      </div>
    </div>
  );
}
